const vwn = {
  appConfig: {
    brandName: 'vwn',
    language: 'de-DE',
    isCarTypeSelectionEnabled: true
  }
};

export default vwn;
